module.exports = __webpack_public_path__ + "img/surprised.be5030ca.webp";